import { render, staticRenderFns } from "./zhongbiaoDetail.vue?vue&type=template&id=7b447ba3&scoped=true"
import script from "./zhongbiaoDetail.vue?vue&type=script&lang=js"
export * from "./zhongbiaoDetail.vue?vue&type=script&lang=js"
import style0 from "./zhongbiaoDetail.vue?vue&type=style&index=0&id=7b447ba3&prod&lang=less"
import style1 from "./zhongbiaoDetail.vue?vue&type=style&index=1&id=7b447ba3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b447ba3",
  null
  
)

export default component.exports